















































import { Component, Vue } from "vue-property-decorator";
import { Cell, Checkbox, CheckboxGroup, Button } from "vant";
import CustomSelect from "../components/CustomSelect.vue";


@Component({
  components: {
    [Cell.name]: Cell,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    customSelect: CustomSelect,
    [Button.name]: Button
  }
})
export default class Finance extends Vue {
  list = [
    {
      label: "每年收入（港币）",
      value: "",
      options: [
        {
          text: "20万以下",
          value: 1
        },
        {
          text: "20万~50万",
          value: 2
        },
        {
          text: "50万~100万",
          value: 3
        },
        {
          text: "100万~500万",
          value: 4
        },
        {
          text: "500万以上",
          value: 5
        }
      ]
    },

    {
      label: "总资产净值（港币）",
      value: "",
      options: [
        {
          text: "50万以下",
          value: 1
        },
        {
          text: "50万~250万",
          value: 2
        },
        {
          text: "250万~500万",
          value: 3
        },
        {
          text: "500万以上",
          value: 4
        }
      ]
    },

    {
      label: "财务来源（可多选）",
      type: "checkbox",
      value: [],
      options: [
        {
          text: "薪水",
          value: 1
        },
        {
          text: "佣金",
          value: 2
        },
        {
          text: "营业盈利",
          value: 3
        },
        {
          text: "租金",
          value: 4
        },
        {
          text: "股利/股息",
          value: 5
        },
        {
          text: "退休金",
          value: 6
        },
        {
          text: "其他",
          value: 7
        }
      ]
    },

    {
      label: "投资知识",
      value: "",
      options: [
        {
          text: "精通",
          value: 1
        },
        {
          text: "良好",
          value: 2
        },
        {
          text: "较好",
          value: 3
        },
        {
          text: "有限",
          value: 4
        },
        {
          text: "全无",
          value: 5
        }
      ]
    },

    {
      label: "投资目标（可多选）",
      type: "checkbox",
      value: [],
      options: [
        {
          text: "资产增值",
          value: 1
        },
        {
          text: "投机",
          value: 2
        },
        {
          text: "对冲",
          value: 3
        },
        {
          text: "其他",
          value: 4
        }
      ]
    },
    {
      label: "每月交易频次",
      value: "",
      options: [
        {
          text: "0～5次",
          value: 1
        },
        {
          text: "5～20次",
          value: 2
        },
        {
          text: "20次以上",
          value: 3
        }
      ]
    },
    {
      label: "风险承受能力",
      value: "",
      options: [
        {
          text: "高风险",
          value: 1
        },
        {
          text: "中等风险",
          value: 2
        },
        {
          text: "低风险",
          value: 3
        }
      ]
    }
  ];

  get isNextDisabled() {
    return this.list.some(item => {
      if (typeof item.value == "string") {
        return item.value == "";
      } else if (
        Object.prototype.toString.call(item.value) == "[object Array]"
      ) {
        return item.value.length === 0;
      }
    });
  }

  handleNextStep() {
    // bus.$emit("financeList", this.list);
    window.sessionStorage.setItem("financeList", JSON.stringify(this.list));
    this.$router.push("/survey/investment");
  }
}
